module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $, undefined) {
	"use strict";

	fox.registerWidget('Conversation_AttachUnlocker', {
		_validator: null,

		configure: function () {
			this.errors = {
				'01': 'Required parameters missing',
				'2004': 'Entry params content is empty',
				'2005': 'Entry params attach is empty'
			};

			this.payData = {};

			this.registerOptions('', {
				dataValidators: {
					price: [
						{validator: 'mandatory'},
						{validator: 'range', options: {min: 1}},
						{validator: 'regexp', options: {type: 'decimal'}}
					],
					messageAttachmentId: [
						{validator: 'mandatory'},
						{validator: 'range', options: {min: 1}},
						{validator: 'regexp', options: {type: 'int'}}
					],
					title: [
						{validator: 'mandatory'}
					]
				},
				widgets: {
					prepareTransactionApi: {
						widget: 'Api',
						method: 'Client_Upload.payPrivate'
					},
					popup: {
						widget: 'Dialog',
						useUiPosition: true,
						preventHideOnShadowClick: true,
						template: '',
						'dialog.autoOpen': false,
						'dialog.closeText': '',
						'dialog.width': '100%',
						widgets: {
							confirm: {
								widget: 'Widget',
								template: 'transaction_confirmation'
							},
							success: {
								widget: 'Widget',
								template: 'transaction_success'
							},
							error: {
								widget: 'Widget',
								template: 'transaction_error'
							}
						}
					},
					billerForm: {
						widget: 'Widget',
						autoRender: false,
						embed: {
							container: 'body',
							widget: '@root',
							location: 'firstChild'
						},
						template: 'transaction_biller_form'
					}
				},
				handleWom: {
					successTransacrionsApi: {
						event: 'success',
						widget: '#prepareTransactionApi',
						callback: 'successPrepareTransaction'
					},
					errorTransacrionsApi: {
						event: ['error', 'failure'],
						widget: '#prepareTransactionApi',
						callback: function (res, p, evalias) {
							res = res.answer;

							this._cleanPayObjectData()._throwError(res.code, res.reason);
						}
					}
				},
				handleDom: {
					confirmUnlock: {
						event: 'click',
						target: '#confirm-unlock',
						targetWidget: '#popup #confirm',
						callback: function (el, alias, scope) {
							var
								api = this.rwom1('#prepareTransactionApi');

							$(el).prop('disabled', true);
							
							this._prepareTransaction();
						}
					},
					closeFromError: {
						event: 'click',
						target: '#close-tr-popup',
						targetWidget: '#popup #error',
						callback: '#popup:hide'
					},
					closeFromSuccess: {
						event: 'click',
						target: '#close-tr-popup',
						targetWidget: '#popup #success',
						callback: '#popup:hide'
					},
					commonClose: {
						event: 'click',
						target: '.close',
						targetWidget: '#popup .Widget',
						callback: '#popup:hide'	
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this.transactionInProgress = false;

			this.registerOptions('#popup .Widget', {
				autoRender: false,
				active: false,
				group: 'popupStates',
				'embed.container': '.ui-dialog-content'
			});

			this._cleanPayObjectData();
		
			this.callParent('init', arguments);
		},

		running: function () {
			this.setupValidators();
			this.rwom1('#billerForm')._readyToRender = false;
		
			this.callParent('running', arguments);
		},

		setupValidators: function () {
			this._validator = new fox.Validator();
			this._validator.setRules(this.getOption('dataValidators'));
		},

		pay: function (params) {
			if (this.transactionInProgress === false) {
				if (this._setPayObjectData(params)) {
					this._showConfirm();
				}
			}
		},

		_prepareTransaction: function () {
			var
				api = this.rwom1('#prepareTransactionApi'),
				linkerParam = this.rwom1('@root #googleAnalytics').getLinkerParam()
			;

			if (linkerParam) {
				this.payData['transitParams[_ga]'] = linkerParam;
			}

			this.transactionInProgress = true;
			api.send(this.payData);
		},

		_setPayObjectData: function (data) {
			var
				dataValidators = this.getOption('dataValidators'),
				infoStatus = true;

			fox.each(dataValidators, function(opt, field) {
				if (fox.isSet(data[field]) && this._validator.validate(field, data[field])) {
					this.payData[field] = data[field];
				} else {
					this._throwError('01');
					infoStatus = false;

					throw fox.break;
				}
			}, this);

			// fox.each(data, function (val, key) {
			// 	if (fox.isSet(dataValidators[key]) && this._validator.validate(key, val)) {
			// 		this.payData[key] = val;
			// 	} else {
			// 		this._throwError('01');
			// 		infoStatus = false;
			//
			// 		throw fox.break;
			// 	}
			// }, this);

			return infoStatus;
		},

		_throwError: function (errorCode, msg) {
			var
				p = this.rwom1('#popup'),
				error = p.rwom1('#error');

			p.switchEmbeddedWidget(error.alias);
			error.setTemplateOptions('reason', this.errors[errorCode] || msg).render();
			p.setTitle('Oops, something went wrong').show();
		},

		_cleanPayObjectData: function () {
			this.payData = {};

			return this;
		},

		_showConfirm: function () {
			var
				p = this.rwom1('#popup'),
				confirm = p.rwom1('#confirm');

			p.switchEmbeddedWidget(confirm.alias);
			confirm.setTemplateOptions('price', this.payData.price).render();
			p.setTitle('Attention').show();

			return this;
		},

		_showSuccess: function () {
			var
				p = this.rwom1('#popup'),
				success = p.rwom1('#success');

			p.switchEmbeddedWidget(success.alias);
			success.setTemplateOptions('name', fox.site.member.getObjectValue('login'));
			success.render();
			p.setTitle(['Thank you', fox.site.member.getObjectValue('login')].join(' ')).show();

			return this;
		},

		_transactionSuccessfully: function () {
			var data = {
				id: this.payData.messageAttachmentId,
				price: this.payData.price,
				title: this.payData.title
			};

			this.dispatchEvent('transactionSuccessfully', data);
			fox.wom.selectFirst('@root').dispatchEvent('unlockTransactionSuccessfully', data);

			this._cleanPayObjectData();
		},

		sendBillerForm: function (formData) {
			var
				f = this.rwom1('#billerForm'),
				fElement;

			f._readyToRender = true;
			f.setTemplateOptions(formData).render();

			this.waitEvent(f, 'addedToDom', function () {
				f._readyToRender = false;
				fElement = f.element[0];

				if (fElement.tagName && fElement.tagName.toLowerCase() === 'form') {
					fElement.submit();
				}
			});
		},

		successPrepareTransaction: function (res) {
			this.transactionInProgress = false;
			res = res.answer.response;

			if (res === true) {
				this._transactionSuccessfully();
				this._showSuccess();

			} else if (res.ubs_transaction_id) {
				this.sendBillerForm(res);
			}
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/conversation/attachUnlocker.js
// module id = 861
// module chunks = 4